import { DEFAULT_LANGUAGE, LANG_MODE_DEFAULT } from '../../constants';

const COMMIT_LANG = 'COMMIT_LANG';
const COMMIT_LANG_TYPE = 'COMMIT_LANG_TYPE';
const COMMIT_USERPREFER = 'COMMIT_USERPREFER';
const COMMIT_BACKENDKEWORDS = 'COMMIT_BACKENDKEWORDS';
const COMMIT_IS_MACHINE_TRANS = 'COMMIT_IS_MACHINE_TRANS';

export default {
    namespaced: true,
    state: {
        lang: {
            left: DEFAULT_LANGUAGE,
            right: DEFAULT_LANGUAGE
        },
        langType: {
            left: LANG_MODE_DEFAULT,
            right: LANG_MODE_DEFAULT
        },
        // 包含谷歌翻译和AI翻译
        isMachineTrans: {
            left: false,
            right: false
        },
        userPreferredLangOption: {
            left: { lang: DEFAULT_LANGUAGE, langType: LANG_MODE_DEFAULT },
            right: { lang: DEFAULT_LANGUAGE, langType: LANG_MODE_DEFAULT }
        },
        backendKeywords: []
    },
    mutations: {
        [COMMIT_LANG](state, { side, value }) {
            state.lang[side] = value;
        },
        [COMMIT_LANG_TYPE](state, { side, value }) {
            state.langType[side] = value;
        },
        [COMMIT_IS_MACHINE_TRANS](state, { side, status }) {
            state.isMachineTrans[side] = status;
        },
        [COMMIT_USERPREFER](state, { side, value }) {
            state.userPreferredLangOption[side] = { ...value };
        },
        [COMMIT_BACKENDKEWORDS](state, payload) {
            state.backendKeywords = payload || [];
        }
    },
    getters: {
        lang: state => state.lang,
        langType: state => state.langType,
        isMachineTrans: state => state.isMachineTrans,
        alterationMode: state => ({ left: state.langType.left !== LANG_MODE_DEFAULT, right: state.langType.right !== LANG_MODE_DEFAULT }),
        userPreferredLangOption: state => state.userPreferredLangOption,
        backendKeywords: state => state.backendKeywords
    },
    actions: {
        setLang({ commit }, { side = 'left', lang = DEFAULT_LANGUAGE, langType = LANG_MODE_DEFAULT } = { }) {
            if (side !== 'both') {
                commit(COMMIT_LANG, { side, value: lang });
                commit(COMMIT_LANG_TYPE, { side, value: langType });
            } else {
                commit(COMMIT_LANG, { side: 'left', value: lang });
                commit(COMMIT_LANG_TYPE, { side: 'left', value: langType });
                commit(COMMIT_LANG, { side: 'right', value: lang });
                commit(COMMIT_LANG_TYPE, { side: 'right', value: langType });
            }
        },
        setUserPreferredLangOption({ commit }, { side = 'left', lang = DEFAULT_LANGUAGE, langType = LANG_MODE_DEFAULT } = { }) {
            if (side !== 'both') {
                commit(COMMIT_USERPREFER, { side, value: { lang, langType } });
            } else {
                commit(COMMIT_USERPREFER, { side: 'left', value: { lang, langType } });
                commit(COMMIT_USERPREFER, { side: 'right', value: { lang, langType } });
            }
        },
        updateBackendKeywords({ commit }, newKeywords) {
            commit(COMMIT_BACKENDKEWORDS, newKeywords);
        },
        setIsMachineTrans({ commit }, { side, status }) {
            if (side !== 'both') {
                commit(COMMIT_IS_MACHINE_TRANS, { side, status });
            } else {
                commit(COMMIT_IS_MACHINE_TRANS, { side: 'left', status });
                commit(COMMIT_IS_MACHINE_TRANS, { side: 'right', status });
            }
        }
    }
};
